import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import style from './DownloadInvoice.module.scss';
import { DefaultErrMsg, isValidEmail } from '../../lib/common';
import { server } from '../../config';
import { PostGenericApiCall } from '../../api';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';

const DownloadInvoice = (props) => {
  const { invoData, selectedBusinessData, setGenInvoClick, setAlert, genInvoClick } = props;
  const selectedInvoType = genInvoClick?.invoType === 'ecsinvoice' ? 'ecs_invoice' : 'htmlInvoice_new';
  const [invSelect, setInvSelect] = useState({});
  const [emailData, setEmailData] = useState('');
  const modelRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const downloadInvoice = async () => {
    const url = `${server.apiURL}csportal/fetchInvoicePdf`;
    if (!invSelect?.version) {
      setAlert({ message: 'Please select deal date to download invoice', status: false });
      return;
    }
    document.body.style.overflow = 'unset';
    const inDetailsData = {
      parentid: selectedBusinessData.parentid,
      data_city: selectedBusinessData.data_city,
      version: invSelect?.version,
      invoType: selectedInvoType,
      instrumentId: invSelect?.instrumentId || '',
    };
    const invoiceDetails = await PostGenericApiCall(url, inDetailsData);
    if (invoiceDetails?.errorCode === 0 && invoiceDetails?.result?.download_url) {
      const fileUrl = invoiceDetails?.result?.download_url;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setAlert({ message: invoiceDetails?.message || '', status: true });
    } else {
      setAlert({ message: invoiceDetails?.message || DefaultErrMsg, status: false });
    }
    setGenInvoClick({ clicked: false, invoData: [] });
  };

  const shareInvoice = async () => {
    if (!invSelect?.version) {
      setAlert({ message: 'Please select the deal date to share invoice', status: false });
      return;
    }
    document.body.style.overflow = 'unset';
    const url = `${server.apiURL}csportal/shareInvoicePdf`;
    const validEmail = isValidEmail(emailData);
    if (validEmail) {
      const commsData = {
        email_id: emailData,
        BUSINESS_OWNER: selectedBusinessData?.contact_person || 'USER',
        COMPANY_NAME: selectedBusinessData?.compname,
        parentid: selectedBusinessData.parentid,
        data_city: selectedBusinessData.data_city,
        version: invSelect?.version,
        invoType: selectedInvoType,
        instrumentId: invSelect?.instrumentId || '',
      };
      const comData = await PostGenericApiCall(url, commsData);
      if (comData?.errorCode === 0) {
        setAlert({ message: comData?.message || 'Communication sent successfully', status: true });
      } else {
        setAlert({ message: comData?.message || DefaultErrMsg, status: false });
      }
      setGenInvoClick({ clicked: false, invoData: [] });
    } else {
      setAlert({ message: 'Invalid email id entered' || DefaultErrMsg, status: false });
    }
  };

  const invoCheck = async (e, item, idx) => {
    if (e?.target?.checked) {
      setInvSelect(item);
      setSelectedIndex(idx);
    } else {
      setInvSelect({});
      setSelectedIndex(null);
    }
  };

  useClickAwayListener(modelRef, () => {
    document.body.style.overflow = 'unset';
    setGenInvoClick({ clicked: false, invoData: [] });
  });
  const disableBtn = !invSelect || Object.keys(invSelect).length === 0;
  return (
    <>
      <section className={`cs_modal ${style.DownloadInvoice}`}>
        <div ref={modelRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${style.Content}`}>
          <div className="cs_modal_header pt-20 pl-20 pr-20 pb-20">
            <div className={`cs_modal_head_center text_left  ${style.HeadCenter}`}>
              <div className={`font16 fw600 color111 `}>Download Recent Invoice</div>
            </div>
            <div className="cs_modal_head_right">
              <div
                className={`${style.Close} cs_modal_close csicon`}
                onKeyDown={() => {}}
                tabIndex={0}
                role="button"
                aria-label="close"
                onClick={() => {
                  document.body.style.overflow = 'unset';
                  setGenInvoClick({ clicked: false, invoData: [] });
                }}
              />
            </div>
          </div>
          <div className={`${style.Body} cs_modal_body pl-20 pr-20 pb-20`}>
            <ul className={`${style.List}`}>
              <li className={`${style.Item} ${style.ItemHead}`}>
                <div className={`${style.ItemLabel} font13 fw400 color777`}>Deal Date</div>
                <div className={`${style.ItemText} font13 fw400 color777`}>Version</div>
              </li>
              {invoData?.map((item, idx) => (
                <li className={`${style.Item}`} key={`download-${idx}`}>
                  <div className={`${style.ItemLabel}`}>
                    <label className={` ${style.Checkbox__Lable}`} htmlFor={`checkbox-invo-${idx}`}>
                      <input
                        className={`${style.Checkbox__Input} `}
                        type="checkbox"
                        id={`checkbox-invo-${idx}`}
                        onClick={(e) => invoCheck(e, item, idx)}
                        checked={selectedIndex === idx}
                        readOnly
                      />
                      <span className={`${style.Checkbox__Icon} csicon `} />
                      <span className={` ${style.Checkbox__Text} font13 fw500 color111 pl-10`}>
                        {item?.entryDate || '--'}{' '}
                      </span>
                    </label>
                  </div>
                  <div className={`${style.ItemText} font13 fw500 color111`}>{item?.version}</div>
                </li>
              ))}
            </ul>
            <div className={`${style.InputBox} mt-20`}>
              <div className="font14 fw500 color111">Share on Email</div>
              <div className={`${style.InputGroup} mt-12`}>
                <input
                  className={`${style.Input} font13 fw400 color111`}
                  type="email"
                  placeholder="Enter Email Id"
                  onChange={(e) => setEmailData(e.target.value)}
                />
                <button
                  disabled={!emailData}
                  className={`${style.InputButton} ${emailData ? 'blue_whitefill_animate' : ''} font13 fw400 color007`}
                  type="button"
                  onClick={() => shareInvoice()}
                >
                  Share
                </button>
              </div>
            </div>
          </div>
          <div className={`${style.ButtonGroup}`}>
            <button
              disabled={disableBtn}
              className={`${style.Button} ${!disableBtn ? 'bluefill_animate' : ''} font14 fw600 colorFFF`}
              type="button"
              onClick={() => downloadInvoice()}
            >
              Download
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

DownloadInvoice.propTypes = {
  invoData: PropTypes.any,
  selectedBusinessData: PropTypes.any,
  setGenInvoClick: PropTypes.func,
  setAlert: PropTypes.func,
  genInvoClick: PropTypes.object,
};

export default DownloadInvoice;
